import { gql } from "@apollo/client";

export const GET_MATCHES_BY_SEASON_ID = gql`
  query matchesBySeasonId($id: Long) {
    matchesBySeasonId(id: $id) {
      id
      homeTeam {
        id
        name
      }
      awayTeam {
        id
        name
      }
      startDate
      hasBeenPlayed
      homeScore
      awayScore
      matchType
      groupType
      knockoutType
    }
  }
`;

export const GET_MATCH_BY_ID = gql`
  query match($id: Long) {
    match(id: $id) {
      id
      homeTeam {
        id
        name
      }
      awayTeam {
        id
        name
      }
      startDate
      hasBeenPlayed
      season {
        id
        name
        startDate
        endDate
        competition {
          id
          name
        }
      }
      homeScore
      awayScore
      matchType
      groupType
      knockoutType
    }
  }
`;

export const ADD_MATCH = gql`
  mutation createMatch(
    $seasonId: Long!
    $awayTeamId: Long!
    $homeTeamId: Long!
    $startDate: Date!
    $hasBeenPlayed: Boolean!
    $homeScore: Int!
    $awayScore: Int!
    $matchType: MatchType!
    $groupType: GroupType
    $knockoutType: KnockoutType
  ) {
    createMatch(
      seasonId: $seasonId
      awayTeamId: $awayTeamId
      homeTeamId: $homeTeamId
      startDate: $startDate
      hasBeenPlayed: $hasBeenPlayed
      homeScore: $homeScore
      awayScore: $awayScore
      matchType: $matchType
      groupType: $groupType
      knockoutType: $knockoutType
    ) {
      id
      homeTeam {
        id
        name
      }
      awayTeam {
        id
        name
      }
      startDate
      hasBeenPlayed
      season {
        id
        name
        startDate
        endDate
        competition {
          name
        }
      }
      homeScore
      awayScore
      matchType
      groupType
      knockoutType
    }
  }
`;

export const UPDATE_MATCH = gql`
  mutation updateMatch(
    $id: Long!
    $startDate: Date!
    $hasBeenPlayed: Boolean!
    $homeScore: Int!
    $awayScore: Int!
    $matchType: MatchType!
    $groupType: GroupType
    $knockoutType: KnockoutType
  ) {
    updateMatch(
      id: $id
      startDate: $startDate
      hasBeenPlayed: $hasBeenPlayed
      homeScore: $homeScore
      awayScore: $awayScore
      matchType: $matchType
      groupType: $groupType
      knockoutType: $knockoutType
    ) {
      id
      homeTeam {
        id
        name
      }
      awayTeam {
        id
        name
      }
      startDate
      hasBeenPlayed
      season {
        id
        name
        startDate
        endDate
        competition {
          name
        }
      }
      homeScore
      awayScore
      matchType
      groupType
      knockoutType
    }
  }
`;

export const DELETE_MATCH = gql`
  mutation deleteMatch($id: Long!) {
    deleteMatch(id: $id) {
      id
      homeTeam {
        id
        name
      }
      awayTeam {
        id
        name
      }
      startDate
      hasBeenPlayed
      season {
        id
        name
        startDate
        endDate
        competition {
          name
        }
      }
      homeScore
      awayScore
    }
  }
`;

export const MATCHES_WITH_PERMISSION = gql`
  query matchesWithPermission {
    matchesWithPermission {
      id
    }
  }
`;
